export default __webpack_public_path__ + "static/media/The_Nest_large_10.b3ac2e6b.jpg";